export default __webpack_public_path__ + "static/media/open-chevron.80a8d904.svg";